const routes = [
  {
    path: '/online-presence',
    name: 'OnlinePresence',
    component: () => import(/* webpackChunkName: "OnlinePresencePage" */ './views/OnlinePresencePage.vue'),
    meta: {
      i18n: 'online-presence-pov',
      pageNameEn: 'Online Presence',
    },
  },
  {
    path: '/online-presence/customize/:widgetType',
    name: 'OnlinePresenceCustomize',
    component: () => import(/* webpackChunkName: "CustomizeWidgetPage" */ './views/CustomizeWidgetPage.vue'),
    props: true,
    meta: {
      i18n: 'online-presence-pov',
      pageNameEn: 'Customize Widget',
    },
  },
];

export default routes;
